import React from 'react'

import bgLineSvg from '../../../../assets/bg-line.svg'
import './styles.css'

interface Props {
  onComplete?: () => void
  children: React.ReactElement | React.ReactElement[]
}

const CyberPunkContainer: React.FC<Props> = ({ children }) => {
  return (
    <div className='fullscreen-cyberpunk-overlay'>
      <div className='bg-line-container'>
        <img src={bgLineSvg} alt='Background lines' className='bg-line-svg' />
      </div>

      <div className='fullscreen-cyberpunk-container'>
        {children}

        <div className='neon-border top' />
        <div className='neon-border right' />
        <div className='neon-border bottom' />
        <div className='neon-border left' />

        <div className='corner-accent top-left' />
        <div className='corner-accent top-right' />
        <div className='corner-accent bottom-left' />
        <div className='corner-accent bottom-right' />
      </div>
    </div>
  )
}

export default CyberPunkContainer
